import { Component, ChangeDetectionStrategy } from '@angular/core'
import { SupportComponent } from '../support/support.component'

@Component({
  selector: 'app-failure-message',
  templateUrl: './failure-message.component.html',
  styleUrls: ['./failure-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SupportComponent],
})
export class FailureMessageComponent {}
